"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["Silent"] = 0] = "Silent";
    LogLevel[LogLevel["Error"] = 1] = "Error";
    LogLevel[LogLevel["Warn"] = 2] = "Warn";
    LogLevel[LogLevel["Info"] = 3] = "Info";
    LogLevel[LogLevel["Verbose"] = 4] = "Verbose";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var Logger = (function () {
    function Logger(rawContext, logHandlers) {
        if (rawContext === void 0) { rawContext = 'PF'; }
        if (logHandlers === void 0) { logHandlers = new Array(); }
        this.rawContext = rawContext;
        this.logHandlers = logHandlers;
    }
    Logger.prototype.withContext = function (additionalContext) {
        return new Logger(this.rawContext + ":" + additionalContext, this.logHandlers);
    };
    Logger.prototype.addLogger = function (logHandler) {
        this.logHandlers.push(logHandler);
    };
    Logger.prototype.verbose = function () {
        var _this = this;
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        this.logHandlers.forEach(function (handler) { return handler.logLevel >= LogLevel.Verbose && handler.verbose.apply(handler, [_this.context].concat(messages)); });
    };
    Logger.prototype.info = function () {
        var _this = this;
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        this.logHandlers.forEach(function (handler) { return handler.logLevel >= LogLevel.Info && handler.info.apply(handler, [_this.context].concat(messages)); });
    };
    Logger.prototype.warn = function () {
        var _this = this;
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        this.logHandlers.forEach(function (handler) { return handler.logLevel >= LogLevel.Warn && handler.warn.apply(handler, [_this.context].concat(messages)); });
    };
    Logger.prototype.error = function () {
        var _this = this;
        var messages = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            messages[_i] = arguments[_i];
        }
        this.logHandlers.forEach(function (handler) { return handler.logLevel >= LogLevel.Error && handler.error.apply(handler, [_this.context].concat(messages)); });
    };
    Object.defineProperty(Logger.prototype, "context", {
        get: function () {
            return "[" + this.rawContext + "]";
        },
        enumerable: true,
        configurable: true
    });
    return Logger;
}());
exports.Logger = Logger;
function createConsoleLogHandler(logLevel) {
    return {
        logLevel: logLevel,
        verbose: console.debug,
        info: console.log,
        warn: console.warn,
        error: console.error,
    };
}
exports.createConsoleLogHandler = createConsoleLogHandler;
exports.defaultLogger = new Logger();
